import { auditApi as maintenanceAuditApi } from '@/api/maintenance/maintenance.js'
import { auditApi as specialAuditApi } from '@/api/task/special.js'
import { auditApi as improveAuditApi } from '@/api/improve/record.js'
import { auditApi as anomalyAuditApi } from '@/api/attendance/anomaly.js'
import { isTenantAdminRole } from '@/utils/adminMenuPermission.js'
import { canQuickAudit, parseUserRoleId } from '@/utils/workbenchAudit.logic.js'

export { canQuickAudit }

export function getCurrentAdminUser() {
  try {
    const raw = JSON.parse(localStorage.getItem('user') || '{}')
    return raw?.users || raw?.user?.users || null
  } catch {
    return null
  }
}

export function auditWorkbenchItem(row, approved) {
  const user = getCurrentAdminUser()
  if (!user?.id) {
    return Promise.reject(new Error('not_logged_in'))
  }

  switch (row.type) {
    case 'maintenance':
      return maintenanceAuditApi(JSON.stringify({
        id: row.id,
        status: approved ? 2 : 4,
      }))
    case 'special':
      return specialAuditApi(JSON.stringify({
        id: row.id,
        status: approved ? 2 : 3,
        comment: '',
        replied_by: user.id,
        replied_name: user.realName || user.real_name || user.username || '',
      }))
    case 'improve':
      return improveAuditApi(JSON.stringify({
        id: row.id,
        status: approved ? 3 : 4,
        comment: '',
        replied_by: user.id,
        replied_name: user.realName || user.real_name || user.username || '',
      }))
    case 'anomaly': {
      const roleId = parseUserRoleId(user)
      const isAdmin = isTenantAdminRole(roleId)
      const action = approved
        ? (isAdmin ? 'admin_pass' : 'captain_pass')
        : (isAdmin ? 'admin_reject' : 'captain_reject')
      return anomalyAuditApi(JSON.stringify({
        id: row.id,
        auditor_id: user.id,
        action,
        remark: '',
      }))
    }
    default:
      return Promise.reject(new Error('unsupported_type'))
  }
}
